(function ($) {
  Drupal.behaviors.setLocaleCookieV1 = {
    attach: function () {
      this.setLocaleCookie();
    },
    setLocaleCookie: function () {
      // Fix LOCALE cookie value if we're in CA FR site.
      if (window.top.document.location.hostname.match(/fr/gu) && $('html').attr('lang') === 'fr') {
        $.cookie('LOCALE', 'fr_CA', {
          path: '/'
        });
      } else {
        $.cookie('LOCALE', 'en_CA', {
          path: '/'
        });
      }
    }
  };
})(jQuery);
